import { defineMessages } from 'react-intl';

export default defineMessages({
    loadingNextPageMessage: {
        id: 'renewal.ea.views.ea-vehicle-details.Loading next page...',
        defaultMessage: 'Loading next page...'
    },
    eaVehicleInformationTitle: {
        id: 'renewal.ea.views.ea-vehicle-details.Vehicle Information',
        defaultMessage: 'Vehicle Information'
    },
    eaVehicleInformationSubHeader: {
        id: 'renewal.ea.views.ea-vehicle-details.Complete the required information for each vehicle added from pre-fill. Add additional vehicles by clicking the "ADD VEHICLE" button',
        defaultMessage: 'Complete the required information for each vehicle added from pre-fill. Add additional vehicles by clicking the "ADD VEHICLE" button'
    },
    paVehicleTitle: {
        id: 'renewal.ea.views.ea-vehicle-details.Vehicle',
        defaultMessage: 'Vehicle'
    },
    paVehicleTitleNumber: {
        id: 'renewal.ea.views.ea-vehicle-details.Vehicle:',
        defaultMessage: 'Vehicle:'
    },
    paAddAnotherVehicleTitle: {
        id: 'renewal.ea.views.ea-driver-details.Add Another Vehicle?',
        defaultMessage: 'Add Another Vehicle?'
    },
    paAddDriverButtonText: {
        id: 'renewal.ea.views.ea-driver-details.Add Vehicle',
        defaultMessage: 'Add Vehicle'
    },
    fillInMsg: {
        id: 'renewal.ea.directives.templates.ea-edit-vehicle.fillInMsg',
        defaultMessage: 'After you enter a VIN and move to the next field, the Make, Model and Year fields will be filled in automatically if possible.'
    },
    additionalInterestsForThisVehicle: {
        id: 'renewal.ea.views.ea-vehicle-details.Additional Interests for This Vehicle',
        defaultMessage: 'Additional Interests for This Vehicle'
    },
    paAddAdditionalInterestType: {
        id: 'renewal.views.ea.ho-your-home.additional-interest.Type',
        defaultMessage: 'Type'
    },
    paAddAdditionalInterestFirstName: {
        id: 'renewal.views.ea.ho-your-home.additional-interest.First Name',
        defaultMessage: 'First Name'
    },
    paAddAdditionalInterestLastName: {
        id: 'renewal.views.ea.ho-your-home.additional-interest.Last Name',
        defaultMessage: 'Last Name'
    },
    paAddAdditionalInterestCountry: {
        id: 'renewal.views.ea.ho-your-home.additional-interest.Country',
        defaultMessage: 'Country'
    },
    paAddAdditionalInterestAddress: {
        id: 'renewal.views.ea.ho-your-home.additional-interest.Address',
        defaultMessage: 'Address'
    },
    paAddAdditionalInterestCity: {
        id: 'renewal.views.ea.ho-your-home.additional-interest.City',
        defaultMessage: 'City'
    },
    paAddAdditionalInterestState: {
        id: 'renewal.views.ea.ho-your-home.additional-interest.State',
        defaultMessage: 'State'
    },
    paAddAdditionalInterestZipCode: {
        id: 'renewal.views.ea.ho-your-home.additional-interest.ZIP Code',
        defaultMessage: 'ZIP code'
    },
    paAddAdditionalInterestInterestType: {
        id: 'renewal.views.ea.ho-your-home.additional-interest.Interest Type',
        defaultMessage: 'Interest Type'
    },
    paAddAdditionalInterestAddressType: {
        id: 'renewal.views.ea.ho-your-home.additional-interest.Address Type',
        defaultMessage: 'Address Type'
    },
    paAddAdditionalInterestPhoneNumber: {
        id: 'renewal.views.ea.ho-your-home.additional-interest.Phone Number',
        defaultMessage: 'Phone Number'
    },
    paAddAdditionalInterestEmail: {
        id: 'renewal.views.ea.ho-your-home.additional-interest.Email',
        defaultMessage: 'Email'
    },
    paAddAdditionalInterestForThisVehicle: {
        id: 'renewal.ea.views.ea-driver-details.Additional Interests for This Vehicle',
        defaultMessage: 'Add Additional Interests for This Vehicle'
    },
    additionalInterestCount: {
        id: 'renewal.views.ea.ea-vehicles.additional-interest.Additional Interest:',
        defaultMessage: 'Additional Interest: { count }'
    },
    PrimaryUse: {
        id: 'renewal.views.ea.ea-vehicles.ea-vehicle-details.PrimaryUse',
        defaultMessage: 'Primary Use'
    },
    VIN: {
        id: 'renewal.views.ea.ea-vehicles.ea-vehicle-details.Vin',
        defaultMessage: 'VIN'
    },
    Year: {
        id: 'renewal.views.ea.ea-vehicles.ea-vehicle-details.Year',
        defaultMessage: 'Year'
    },
    Make: {
        id: 'renewal.views.ea.ea-vehicles.ea-vehicle-details.Make',
        defaultMessage: 'Make'
    },
    Model: {
        id: 'renewal.views.ea.ea-vehicles.ea-vehicle-details.Model',
        defaultMessage: 'Model'
    },
    Series: {
        id: 'renewal.views.ea.ea-vehicles.ea-vehicle-details.Series',
        defaultMessage: 'Series'
    },
    VehicleType: {
        id: 'renewal.views.ea.ea-vehicles.ea-vehicle-details.VehicleType',
        defaultMessage: 'Vehicle Type'
    },
    VehicleCost: {
        id: 'renewal.views.ea.ea-vehicles.ea-vehicle-details.VehicleCostNew',
        defaultMessage: 'Cost New'
    },
    Mileage: {
        id: 'renewal.views.ea.ea-vehicles.ea-vehicle-details.AnnualMileage',
        defaultMessage: 'Annual Mileage'
    },
    CurrentOdometer: {
        id: 'renewal.views.ea.ea-vehicles.ea-vehicle-details.CurrentOdometerReading',
        defaultMessage: 'Current Odometer Reading'
    },
    AutoSafety: {
        id: 'renewal.views.ea.ea-vehicles.ea-vehicle-details.AutoSafety',
        defaultMessage: 'Auto Safety Equipment'
    },
    GaragingAddress: {
        id: 'renewal.views.ea-vehicle-details.GaragingAddress',
        defaultMessage: 'Garaging Address'
    },
    eaDeleteVehicle: {
        id: 'renewal.ea.views.ea-vehicle-details.Delete Vehicle',
        defaultMessage: 'Delete Vehicle'
    },
    eaAddVehicle: {
        id: 'renewal.ea.views.ea-vehicle-details.ADD VEHICLE',
        defaultMessage: 'ADD VEHICLE'
    },
    otherThanNamedInsuredLabel: {
        id: 'renewal.views.ea-vehicle-details.Person(s) other than named insured owns or co-owns this vehicle',
        defaultMessage: 'Person(s) other than named insured owns or co-owns this vehicle'
    },
    antiTheftDevices: {
        id: 'renewal.views.ea-vehicle-details.Anti-Theft Devices',
        defaultMessage: 'Anti-Theft Devices'
    },
    airBagType: {
        id: 'renewal.views.ea-vehicle-details.Airbag Type',
        defaultMessage: 'Airbag Type'
    },
    garagingAddressWarningMessageTextLine1: {
        id: 'renewal.views.ea-vehicle-details.If Residence Address has changed, please update Mailing, Billing and Garaging Address for each vehicle with new Residence Address.',
        defaultMessage: 'If Residence Address has changed, please update Mailing, Billing and Garaging Address for each vehicle with new Residence Address.'
    },
    garagingAddressWarningMessageTextLine2: {
        id: 'renewal.views.ea-vehicle-details.Changes only apply to this policy. Other policies associated to this insured also need to be updated.',
        defaultMessage: 'Changes only apply to this policy. Other policies associated to this insured also need to be updated.'
    },
});
